import type { AriaRole, ReactNode } from 'react'

/**
 * Gabarit plein écran des états d'autorisation du back-office : accès refusé, autorisations
 * indisponibles, aucune page accessible.
 */
export default function RbacStatusPanel({
  role,
  children,
}: {
  role?: AriaRole
  children: ReactNode
}) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-sidebar px-6 py-10">
      <section
        role={role}
        className="w-full max-w-xl rounded-3xl border border-sidebar-border bg-background p-8 text-center shadow-xs"
      >
        {children}
      </section>
    </main>
  )
}
